import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales October 2025 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13) retroactive to 1/1/2025
const jobData = [
  {
    jobInfo: "E-660: Lauren Maxwell",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 14725.17,
    grossMarginPct: 0.4081,
    grossProfit: 6009.34,
    commissionPercentage: 0,
    salesCommission: 0, // Will be calculated
    salesManagerFee: 0,
    companyOH: 14725.17 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-677: Bri Black",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 2188.58,
    grossMarginPct: 0.4654,
    grossProfit: 1018.57,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2188.58 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-639: Solution Based Property Management",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 8330.00,
    grossMarginPct: 0.3029,
    grossProfit: 2523.16,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 8330.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-654: David Futrowsky",
    leadSource: "Referral- Dominic's network",
    trade: "Solar",
    contractTotal: 349.00,
    grossMarginPct: 0.5702,
    grossProfit: 199.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 349.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-655: The Enclave At Ellicott Hills",
    leadSource: "Referral- Dominic's network",
    trade: "Solar",
    contractTotal: 1200.00,
    grossMarginPct: 0.4792,
    grossProfit: 575.04,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1200.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-679: Jesse & Jean Strickland",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 5199.00,
    grossMarginPct: 0.6145,
    grossProfit: 3194.79,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 5199.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-670: CDL Stone Solutions LLC",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 28813.64,
    grossMarginPct: 0.4104,
    grossProfit: 11825.12,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 28813.64 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-663: Greg Cho",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 2700.00,
    grossMarginPct: 0.4152,
    grossProfit: 1121.04,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2700.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-681: Aion Management Mariners Pointe",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 3860.00,
    grossMarginPct: 0.4819,
    grossProfit: 1860.13,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3860.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-674: Montgomery Airpark LLP",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 180216.66,
    grossMarginPct: 0.2731,
    grossProfit: 49217.17,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 180216.66 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-653: John Tabor Peirce Change Order",
    leadSource: "Referral- Cody's network",
    trade: "Windows & Doors",
    contractTotal: 8743.50,
    grossMarginPct: 0.2509,
    grossProfit: 2193.74,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 8743.50 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// For Cody reports: Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesOctoberData: ReportData = {
  kpis: {
    adSpend: 0, // No ad spend for Cody direct sales
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0, // No manager fees in Cody structure
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Google Organic Search", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 10,
    year: 2025
  }
};
